const additionalContactDetailMap = {
  '7-19': 'date_of_birth',
  '5-13': 'website',
};

const getContactDetailId = (n) => {
  const key = `${n.detailTypeId}-${n.detailSubTypeId}`;
  return additionalContactDetailMap[key];
};

export default getContactDetailId;
